import React from 'react';
import Immutable from 'immutable';

import { Node } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { NodePartner } from '../../../types/uncinc_profile/nodes';

import './style.scss';

interface ViewPartnerOverviewProps {
  entities: Immutable.List<ImmutableEntity<NodePartner>>;
}

const ViewPartnersOverview: React.FC<ViewPartnerOverviewProps> = ({
  entities,
}) => (
  <div className="ViewPartnersOverview">
    <div className="row">
      <div className="col-12">
        <div className="ViewPartnersOverview__partners">
          {entities.map((entity) => {
            const partner = entity.toJS();
            const id = partner.nid[0].value;
            const uuid = partner.uuid[0].value;
            const langcode = partner.langcode[0].value;
            const key = `${uuid}:${langcode}`;

            return (
              <Node
                key={key}
                id={id}
                entity={entity}
                viewMode="teaser"
              />
            );
          })}
        </div>
      </div>
    </div>
  </div>
);

export default ViewPartnersOverview;
